import { Component, Inject, OnInit, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { DatePipe } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MAT_DIALOG_DATA, MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatDividerModule } from '@angular/material/divider';

import {
  AbstractControl,
  FormBuilder,
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  ValidationErrors,
  ValidatorFn,
  Validators
} from '@angular/forms';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { delay, take } from 'rxjs';
import { DeleguesService } from 'src/app/services/delegues.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { AlerteModalComponent } from 'src/app/shared/alerte-modal/alerte-modal.component';
import { ValidationModalComponent } from 'src/app/shared/validation-modal/validation-modal.component';
import { CustomLuxonDateAdapter } from 'src/app/shared/utils/custom-luxon-date-adapter';
import { MY_FORMATS } from 'src/app/shared/utils/date-pickr-custom-luxon-format';
import { DateTime } from 'luxon';
import { AgentsService } from 'src/app/core/services/agents.service';
import { RoleService } from 'src/app/core/services/role.service';

@Component({
    selector: 'app-agent-delegation-modal',
    imports: [
    MatIconModule,
    MatCardModule,
    MatDialogModule,
    MatButtonModule,
    MatInputModule,
    MatFormFieldModule,
    MatAutocompleteModule,
    MatDividerModule,
    ReactiveFormsModule,
    MatDatepickerModule,
    MatNativeDateModule
],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    templateUrl: './agent-delegation-modal.component.html',
    styleUrls: ['./agent-delegation-modal.component.scss'],
    providers: [
        { provide: MAT_DATE_LOCALE, useValue: 'fr-FR' },
        { provide: DateAdapter, useClass: CustomLuxonDateAdapter, deps: [MAT_DATE_LOCALE] },
        { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }
    ]
})
export class AgentDelegationModalComponent implements OnInit {
  agentsList: any[] = [];
  filteredOptions: any = [];
  matricule: string;
  datePipe = new DatePipe('fr-FR');
  datesDisabled: string[] = [];
  delegue: any = [];
  userRoles: string[] = [];
  delegationAgent: any = [];
  viewMode: any;
  minDate = new Date();

  formAgentDelegation: FormGroup = this.formBuilder.group({
    agent: new FormControl('', [Validators.required, this.agentMatricule(this.data.nameUser, this.data.agentId)]),
    date_debut: new FormControl('', [Validators.required, this.dateLessThan('date_debut', 'date_fin')]),
    date_fin: new FormControl('', [Validators.required, this.dateLessThan('date_debut', 'date_fin')])
  });

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private readonly formBuilder: FormBuilder,
    private readonly agentService: AgentsService,
    private readonly delegueService: DeleguesService,
    private readonly roleService: RoleService,
    private readonly spinner: NgxSpinnerService,

    public dialog: MatDialog,
    public dialogRef: MatDialogRef<AgentDelegationModalComponent>
  ) {}

  ngOnInit() {
    this.roleService.getRole().subscribe((role) => {
      this.userRoles = role;
    });
    this.minDate = new Date();

    this.formAgentDelegation.get('date_debut')?.valueChanges.subscribe((value) => {
      if (typeof value === 'string' && value.length === 10) {
        const dateValue = DateTime.fromFormat(value, 'DD/MM/YYYY');
        if (dateValue.isValid) {
          this.formAgentDelegation.get('date_debut')?.setValue(dateValue.toJSDate(), { emitEvent: false });
          this.formAgentDelegation.get('date_debut')?.setErrors(null);
        } else {
          this.formAgentDelegation.get('date_debut')?.setErrors({ invalidDate: true });
        }
      }
    });

    this.formAgentDelegation.get('date_fin')?.valueChanges.subscribe((value) => {
      if (typeof value === 'string' && value.length === 10) {
        const dateValue = DateTime.fromFormat(value, 'DD/MM/YYYY');
        if (dateValue.isValid) {
          this.formAgentDelegation.get('date_fin')?.setValue(dateValue.toJSDate(), { emitEvent: false });
          this.formAgentDelegation.get('date_fin')?.setErrors(null);
        } else {
          this.formAgentDelegation.get('date_fin')?.setErrors({ invalidDate: true });
        }
      }
    });

    this.formAgentDelegation.get('date_fin')?.valueChanges.subscribe((value) => {
      const dateDebut = this.formAgentDelegation.get('date_debut')?.value;
      if (dateDebut && value) {
        const dateDebutObj = new Date(dateDebut);
        const dateFinObj = new Date(value);
        if (dateFinObj < dateDebutObj) {
          this.formAgentDelegation.get('date_fin')?.setErrors({ invalidDate: true });
        } else {
          this.formAgentDelegation.get('date_fin')?.setErrors(null);
        }
      }
    });

    if (this.data.modif === true) {
      this.delegue = this.data.delegue;
      this.initFormModif();
    } else {
      this.loadAgents();
      this.datesDisabled = this.data.Dates;

      this.delegationAgent = this.data.DelegationAgent;
      this.matricule = this.data.agentMatricule;
      this.viewMode = this.data.view;

    }
  }

  loadAgents() {
    this.agentService
      .getAllAgentsDemandes('delegation')
      .pipe(take(1))
      .subscribe({
        next: (data) => {
          if (data && Array.isArray(data)) {
            this.agentsList = data;
            this.filteredOptions = [...this.agentsList];
          }
        }
      });
  }

  initFormModif() {

    const agentName = this.delegue?.remplacant;
    this.formAgentDelegation.controls['agent'].setValue(agentName);
    this.formAgentDelegation.controls['date_debut'].setValue(new Date(this.delegue?.dateDebut));

    this.formAgentDelegation.controls['date_fin'].setValue(new Date(this.delegue?.dateFin));
    this.formAgentDelegation.get('agent')?.disable();
  }
  verifAcces() {
    throw new Error('Method not implemented.');
  }

  dateLessThan(start: string, end: string) {
    return (group: AbstractControl): { [key: string]: any } => {
      if (!this.formAgentDelegation) {
        return {};
      }
      let f = this.formAgentDelegation.controls[start];
      let t = this.formAgentDelegation.controls[end];
      if (f && t && f.value && t.value) {
        let startDate = new Date(f.value);
        let endDate = new Date(t.value);
        if (startDate > endDate) {
          t.setErrors({ invalidDate: true });
          return { invalidDate: true };
        }
      }
      return {};
    };
  }

  //Désactiver les dates précédentes
  FilterDebutDate = (date: Date | null): boolean => {
    if (!date) {
      return false;
    }

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const selectedDate = new Date(date);
    selectedDate.setHours(0, 0, 0, 0);

    return selectedDate.getTime() >= today.getTime();
  };

  FilterFinDate = (date: Date | null): boolean => {
    if (!date) {
      return false;
    }

    const dateDebut = this.formAgentDelegation.controls['date_debut'].value;
    const selectedDate = new Date(date);
    selectedDate.setHours(0, 0, 0, 0);

    if (dateDebut) {
      const dateDebutFormatted = new Date(dateDebut);
      dateDebutFormatted.setHours(0, 0, 0, 0);

      return selectedDate.getTime() >= dateDebutFormatted.getTime();
    }

    return true;
  };

  agentMatriculeExist(): boolean {
    const selectedAgent = this.formAgentDelegation.get('agent')?.value;
    return selectedAgent && selectedAgent.matricule === this.matricule;
  }

  agentMatricule(username: string, id: string): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const selectedAgent = control.value;
      if (selectedAgent?.id === id || selectedAgent?.login?.toUpperCase() === username?.toUpperCase()) {
        return { agentExist: true };
      }
      return null;
    };
  }

  agentSelected(event: any): void {
    this.formAgentDelegation.get('agent')?.updateValueAndValidity();
  }
  agentFilter(event: any): void {
    const value = event.target.value;
    if (typeof value !== 'string') {
      this.filteredOptions = [];
      return;
    }
    const filterValue = value.toLowerCase().split(' ').join('');
    this.filteredOptions = this.agentsList.filter((agent: any) =>
      (agent.nom + agent.prenom).toLowerCase().split(' ').join('').includes(filterValue)
    );
  }
  agentDeleguedisplayFn(agent: any): string {
    return agent ? `${agent.nom} ${agent.prenom}` : '';
  }

  effaceFiltreDelegue(event: any, controlName: string) {
    event.stopPropagation();

    if (controlName != undefined && controlName != '') {
      this.formAgentDelegation.controls[controlName].setValue('');
      this.filteredOptions = [...this.agentsList];
    }
  }

  saveDelegue() {
    let role = this.roleService.getRole();

    const { date_debut, date_fin, agent } = this.formAgentDelegation.value;

    const formattedDebutDate = this.datePipe.transform(new Date(date_debut), 'yyyy-MM-dd');
    const formattedFinDate = this.datePipe.transform(new Date(date_fin), 'yyyy-MM-dd');

    const data = {
      dateDebut: formattedDebutDate,
      dateFin: formattedFinDate,
      remplacant: {
        id: agent?.id
      },
      remplace: {
        id: this.data.remplaceId
      }
    };


    if (this.data.view !== 'user' && this.data.modif !== true) {
      this.delegueService
        .AjoutDelegue(data)
        .pipe(take(1))
        .subscribe({
          next: (results) => {
            if (results) {
              this.showConfirmationDialog('La délégation a été créée avec succès.');
            }
          },
          error: (error) => {
            if (error.status === 400 && error.error) {
              this.dialog.open(AlerteModalComponent, {
                width: '640px',
                data: {
                  title: 'Erreur',
                  content: this.getErrorMessage(error)
                }
              });
            }
          }
        });
    } else if (this.data.view === 'user' && this.data.modif !== true) {
      this.delegueService
        .AjoutMonDelegue(data)
        .pipe(take(1))
        .subscribe({
          next: (results) => {
            if (results) {
              this.dialog
                .open(ValidationModalComponent, {
                  width: '600px',
                  data: {
                    title: 'Confirmation',
                    content: 'La délégation a été créée avec succès.'
                  }
                })
                .afterClosed()
                .subscribe((action) => {
                  if (action) {
                    this.dialogRef.close();
                  }
                });
            }
          },
          error: (error) => {
            console.error('Erreur API ajout :', error);
            if (error.status === 400) {
              this.dialog.open(AlerteModalComponent, {
                width: '640px',
                data: {
                  title: 'Erreur',
                  content: this.getErrorMessage(error)
                }
              });
            }
          }
        });
    } else if (this.data.modif === true && this.data.view !== 'user') {
      const delegationId = this.delegue.id;
      const deleguedata = {
        dateDebut: formattedDebutDate,
        dateFin: formattedFinDate,
        id: delegationId,
        remplacant: {
          id: this.delegue.remplacant.id
        },
        remplace: {
          id: this.data.remplaceId
        }
      };


      this.delegueService
        .modifierDelegue(deleguedata, delegationId)
        .pipe(delay(1000))
        .subscribe({
          next: (result) => {
            this.dialogRef.close();
            this.showConfirmationDialog('La délégation a été modifiée avec succès.');
          },
          error: (error) => {
            console.error('Erreur API :', error);
            this.spinner.hide();
            this.dialog.open(AlerteModalComponent, {
              width: '640px',
              data: {
                title: 'Erreur',
                content: error.error.replace('Validation error:', '')
              }
            });
          }
        });
    } else {
      let _data: any = {};
      let delegationId: any;
      _data = this.delegue;

      delegationId = this.delegue.id;

      _data.agent = this.formAgentDelegation.get('agent')?.value;
      const formdata = this.formAgentDelegation.value;

      const DebutDate = this.datePipe.transform(new Date(formdata.date_debut), 'yyyy-MM-dd');
      const FinDate = this.datePipe.transform(new Date(formdata.date_fin), 'yyyy-MM-dd');

      const deleguedata = {
        dateDebut: DebutDate,
        dateFin: FinDate,
        id: delegationId,
        remplacant: {
          id: this.delegue.remplacant.id
        },
        remplace: {
          id: this.data.remplaceId
        }
      };
      this.delegueService
        .modifierMonDelegue(deleguedata, delegationId)
        .pipe(delay(1000))
        .subscribe({
          next: (result) => {
            this.dialogRef.close();
            this.dialog.open(ValidationModalComponent, {
              width: '600px',
              data: {
                title: 'Confirmation',
                content: 'La délégation a été modifiée avec succès.'
              }
            });
          },
          error: (error) => {
            this.spinner.hide();
            this.dialog.open(AlerteModalComponent, {
              width: '640px',
              data: {
                title: 'Erreur',
                content: error.error.replace('Validation error:', '')
              }
            });
          }
        });
    }
  }
  getErrorMessage(error: any): string {
    if (error.status === 400 && error.error) {
      if (typeof error.error === 'string') {
        return error.error.replace('Validation error:', '').trim();
      }
      if (error.error.message) {
        return error.error.message;
      }
      if (Array.isArray(error.error.errors)) {
        return error.error.errors.map((err: { message: string }) => err.message).join(', ');
      }
    }
    return 'Une erreur inattendue est survenue. Veuillez réessayer.';
  }
  showConfirmationDialog(message: string): void {
    this.dialog
      .open(ValidationModalComponent, {
        width: '600px',
        data: { title: 'Confirmation', content: message }
      })
      .afterClosed()
      .subscribe((action) => {
        if (action) {
          this.dialogRef.close();
        }
      });
  }
}
